export default "__VITE_ASSET__rmc5qTF4__"